<div class="overlay" *ngIf="exists" (click)="click()"></div>